import {AnyAction} from "redux";
import {SET_MAP_BOUNDS, SET_MAP_OFFSET} from "../../actions/action";

export interface Rect
{
    width: number;
    height: number;
}

export const getMapBounds = (state) => state.mapBounds;


/**
 * set the bounds of the map
 */
export function mapBounds(state: Rect = { width: 0, height: 0 }, action: AnyAction) : Rect
{
    switch (action.type)
    {
        case SET_MAP_BOUNDS:
        {
            const {payload} = action;
            const {width, height} = payload;

            return {width, height};
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/map/mapBounds.ts